import { useEffect } from "react";

import {
    Grid, Typography, Chip, useMediaQuery, Stack
} from "@mui/material";
import { useTheme } from '@mui/material/styles';

import * as CONSTANTS from "../../constants"

const ReviewForm = ({formik, lang}) => {

    useEffect(() => { window.scrollTo(0, 0) }, []);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection

    const radioButtonMap = {
        'en': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.EN[lang], 
        'jp': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.JP[lang], 
        'sc': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.SC[lang], 
        'tc': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.TC[lang]
    };

    return (
        <Grid
            container
            spacing={2}
        >
            <Grid
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.WAZAREN_UID[lang].toUpperCase()}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.WAZAREN_UID[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.wazaren_uid}</Typography>
            </Grid>
            <Grid
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.NAME[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.EN[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.name_en}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.JP[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.name_jp}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.TC[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.name_tc}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.SC[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.name_sc}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.DEFAULT_LANG[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{radioButtonMap[formik.values.default_language]}</Typography>
            </Grid>
            <Grid
                mt={3}
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.WAZAREN_DETAILS.DESCRIPTION[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.EN[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                
                <Typography>{formik.values.description_en}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.JP[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.description_jp}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.TC[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.description_tc}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.SC[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.description_sc}</Typography>
            </Grid>
            <Grid
                mt={3}
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.OTHER[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WAZAREN_DETAILS.CREATOR[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.creator_name}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WAZAREN_DETAILS.EDITOR[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.editor_name}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WAZAREN_DETAILS.DATE_CREATED[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    {formik.values.date_created? formik.values.date_created.toISOString().slice(0,10): ''}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WAZAREN_FILTER.TAGS[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
            >
                <Stack 
                    className="selectedTags"
                    direction="row" 
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap"
                >
                    {
                        formik.values.tags.map((option, index) => {
                            // This is to handle new options added by the user (allowed by freeSolo prop).
                            const label = CONSTANTS.WAZAREN_TAGS[option][lang] || option;
                            return (
                                <Chip 
                                    size="medium"
                                    variant="outlined"
                                    key={option}
                                    label={label}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 'fit-content',
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                    }}
                                />
                            );
                        })
                    }
                </Stack>
            </Grid>
            <Grid
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.WAZAREN_DETAILS.VIDEO[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    YouTube
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                md={4}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>
                    {formik.values.video_youtube}
                </Typography>
            </Grid>
            { isMobile? <Grid item xs={4} />: <></> }
            <Grid
                item
                xs={8}
                md={4}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>
                    {formik.values.remark_youtube}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    Bilibili
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                md={4}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>
                    {formik.values.video_bilibili}
                </Typography>
            </Grid>
            { isMobile? <Grid item xs={4} />: <></> }
            <Grid
                item
                xs={8}
                md={4}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>
                    {formik.values.remark_bilibili}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    X
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                md={4}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>
                    {formik.values.video_x}
                </Typography>
            </Grid>
            { isMobile? <Grid item xs={4} />: <></> }
            <Grid
                item
                xs={8}
                md={4}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>
                    {formik.values.remark_x}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default ReviewForm;